import { render, staticRenderFns } from "./AssetableNote.vue?vue&type=template&id=21d13a08"
import script from "./AssetableNote.vue?vue&type=script&lang=js"
export * from "./AssetableNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports